import React from "react";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import DangerButton from "./DangerButton";

/**
 * ModalActions - Pre-configured button group for modals
 * 
 * Provides standard Close + Action button pair used in modals
 * 
 * @param {Object} props
 * @param {function} props.onClose - Close button handler
 * @param {function} props.onSubmit - Submit button handler
 * @param {string} props.submitLabel - Label for submit button (default: "Submit")
 * @param {string} props.closeLabel - Label for close button (default: "Close")
 * @param {boolean} props.loading - Loading state for submit button
 * @param {string} props.loadingText - Text when loading (default: "Loading...")
 * @param {string} props.submitVariant - Submit button variant (primary, danger)
 * @param {boolean} props.disabled - Disable submit button
 * @param {string} props.alignment - Button alignment (end, start, center, space-between)
 * 
 * @example
 * <ModalActions
 *   onClose={handleClose}
 *   onSubmit={handleSubmit}
 *   submitLabel="Create Revision"
 *   loading={isCreating}
 *   loadingText="Creating..."
 * />
 */
const ModalActions = ({
  onClose,
  onSubmit,
  submitLabel = "Save",
  closeLabel = "Close",
  loading = false,
  loadingText = "Loading...",
  submitVariant = "primary",
  disabled = false,
  alignment = "end",
  style = {},
}) => {
  const SubmitButton = submitVariant === "danger" ? DangerButton : PrimaryButton;

  const alignmentClass = {
    end: "app-btn-group",
    start: "app-btn-group app-btn-group-start",
    center: "app-btn-group app-btn-group-center",
    "space-between": "app-btn-group app-btn-group-space-between",
  }[alignment] || "app-btn-group";

  return (
    <div className={alignmentClass} style={style}>
      <SecondaryButton onClick={onClose}>
        {closeLabel}
      </SecondaryButton>
      <SubmitButton
        onClick={onSubmit}
        loading={loading}
        loadingText={loadingText}
        disabled={disabled}
      >
        {submitLabel}
      </SubmitButton>
    </div>
  );
};

export default ModalActions;

